'use strict';

export default ($q, $http, utils) => {
  'ngInject';

  return {
    get() {
      var url = utils.getApiUrlV2('/time');
      return new $q((resolve, reject) => {
        $http.get(url)
          .then((response) => resolve(response))
          .catch(reject);
      });
    },
  };
};



// WEBPACK FOOTER //
// ./app/src/services/generation_time.js